import { FieldErrors } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useInstitutionsStore } from '@/stores/institutions';
import { ERouterNames, TFormBuilderEditSchemaCamel } from '@/types';

export const useVisitNoteSubmit = () => {
  const { formBuilderId } = useParams();
  const navigate = useNavigate();
  const currentInstitutionId = useInstitutionsStore(
    (state) => state.currentInstitution?.id ?? '',
  );
  const {
    getVisitNoteTemplateById,
    createVisitNotesTemplate,
    updateVisitNotesTemplate,
  } = useInstitutionsStore((state) => ({
    createVisitNotesTemplate: state.createVisitNotesTemplate,
    getVisitNoteTemplateById: state.getVisitNoteTemplateById,
    updateVisitNotesTemplate: state.updateVisitNotesTemplate,
  }));

  const onSubmit = async (data: TFormBuilderEditSchemaCamel) => {
    if (!formBuilderId) return;
    try {
      if (formBuilderId !== 'empty') {
        const value = getVisitNoteTemplateById(formBuilderId.toString());
        if (!value) return;
        await updateVisitNotesTemplate(value.id, {
          data,
        });
      } else {
        await createVisitNotesTemplate(currentInstitutionId, {
          isActive: true,
          data,
        });
      }
      navigate(ERouterNames.VISIT_NOTES_TEMPLATES);
    } catch (error) {
      console.error(error);
    }
  };

  const onError = (errors: FieldErrors<TFormBuilderEditSchemaCamel>) =>
    console.error('❌ ERRORS:', errors);

  return { onSubmit, onError };
};
